export default {
    activeTab: null,
    eventListing: [],
    gameListing: [],
    resources: {
        athleteFavorites: {},
        athleteSkips: {},
        athletes: {},
        eventTeamAthleteAffiliations: {},
        eventTeams: {},
        events: {},
        gameVideos: {},
        games: {},
        images: {},
        sports: {},
        clubStaffs: {},
        eventDivisions: {}
    },
    pagination: {
        events: {},
        games: {},
    },
    availableEventsFilters: [],
    availableAthleteTeamFilters: [],
    appliedEventsFilters: [],
    appliedAthleteTeamFilters: [],
    recommendedGames: [],
    enableMobile: false,
    fetchState: false,
    countFetchState: false,
    favIntFetchState: false,
    filterFetchState: false,
    teamListingCollapsedStateLeft: false,
    teamListingCollapsedStateRight: false,
    gamesScrollY: 0
}